export abstract class IAPIConfiguration {
  public apiKeys?: { [key: string]: string };
  public username?: string;
  public password?: string;
  public accessToken?: string | (() => string);
  public basePath?: string;
  public withCredentials?: boolean;
}
